import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X, Calendar } from 'lucide-react'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
  ]

  const isActive = (path) => location.pathname === path

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50" data-component-path="client/src/components/Navbar.jsx" data-component-line="1:1" data-component-id="client/src/components/Navbar.jsx:1:1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/components/Navbar.jsx" data-component-line="2:2" data-component-id="client/src/components/Navbar.jsx:2:2">
        <div className="flex justify-between items-center h-20" data-component-path="client/src/components/Navbar.jsx" data-component-line="3:3" data-component-id="client/src/components/Navbar.jsx:3:3">
          <Link to="/" className="flex items-center gap-3 group" data-component-path="client/src/components/Navbar.jsx" data-component-line="4:4" data-component-id="client/src/components/Navbar.jsx:4:4">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg flex items-center justify-center flex-shrink-0" data-component-path="client/src/components/Navbar.jsx" data-component-line="5:5" data-component-id="client/src/components/Navbar.jsx:5:5">
              <span className="text-white font-bold text-xl" data-component-path="client/src/components/Navbar.jsx" data-component-line="6:6" data-component-id="client/src/components/Navbar.jsx:6:6">PN</span>
            </div>
            <div className="flex flex-col" data-component-path="client/src/components/Navbar.jsx" data-component-line="7:7" data-component-id="client/src/components/Navbar.jsx:7:7">
              <span className="font-display font-bold text-xl text-gray-900 group-hover:text-blue-600 transition-colors" data-component-path="client/src/components/Navbar.jsx" data-component-line="8:8" data-component-id="client/src/components/Navbar.jsx:8:8">Paul T. Neustrom</span>
              <span className="text-xs text-gray-600 font-medium" data-component-path="client/src/components/Navbar.jsx" data-component-line="9:9" data-component-id="client/src/components/Navbar.jsx:9:9">Author • Speaker • Coach</span>
            </div>
          </Link>

          <div className="hidden md:flex items-center gap-8" data-component-path="client/src/components/Navbar.jsx" data-component-line="10:10" data-component-id="client/src/components/Navbar.jsx:10:10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-medium transition-colors ${
                  isActive(link.path)
                    ? 'text-blue-600'
                    : 'text-gray-700 hover:text-blue-600'
                }`}
                data-component-path="client/src/components/Navbar.jsx"
                data-component-line="11:11"
                data-component-id="client/src/components/Navbar.jsx:11:11"
              >
                {link.name}
              </Link>
            ))}
            <a
              href="https://calendly.com/terrypaul-llc"
              target="_blank"
              rel="noopener noreferrer"
              className="h-11 px-6 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-200 shadow-md hover:shadow-lg flex items-center justify-center gap-2 focus:ring-4 focus:ring-blue-300/50"
              data-component-path="client/src/components/Navbar.jsx"
              data-component-line="12:12"
              data-component-id="client/src/components/Navbar.jsx:12:12"
            >
              <Calendar className="w-5 h-5 flex-shrink-0" data-component-path="client/src/components/Navbar.jsx" data-component-line="13:13" data-component-id="client/src/components/Navbar.jsx:13:13" />
              Book a Call
            </a>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            data-component-path="client/src/components/Navbar.jsx"
            data-component-line="14:14"
            data-component-id="client/src/components/Navbar.jsx:14:14"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {isOpen && (
          <div className="md:hidden py-4 border-t border-gray-200" data-component-path="client/src/components/Navbar.jsx" data-component-line="15:15" data-component-id="client/src/components/Navbar.jsx:15:15">
            <div className="flex flex-col gap-4" data-component-path="client/src/components/Navbar.jsx" data-component-line="16:16" data-component-id="client/src/components/Navbar.jsx:16:16">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={`font-medium transition-colors ${
                    isActive(link.path)
                      ? 'text-blue-600'
                      : 'text-gray-700 hover:text-blue-600'
                  }`}
                  data-component-path="client/src/components/Navbar.jsx"
                  data-component-line="17:17"
                  data-component-id="client/src/components/Navbar.jsx:17:17"
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="https://calendly.com/terrypaul-llc"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setIsOpen(false)}
                className="h-11 px-6 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-200 shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                data-component-path="client/src/components/Navbar.jsx"
                data-component-line="18:18"
                data-component-id="client/src/components/Navbar.jsx:18:18"
              >
                <Calendar className="w-5 h-5 flex-shrink-0" data-component-path="client/src/components/Navbar.jsx" data-component-line="19:19" data-component-id="client/src/components/Navbar.jsx:19:19" />
                Book a Call
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navbar